export default __webpack_public_path__ + "132c19be9eaba9767a2a616220bb4765.png";